/**
 * 复制 + 复制后弹框信息
 */
import ClipboardIcon from './ClipboardIcon'

ClipboardIcon.install = function (Vue) {
  Vue.component('clipboard-icon', ClipboardIcon)
}

export default ClipboardIcon
